var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgKeyboard = function SvgKeyboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Keyboard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.334 4.667v6.667H2.667V4.667zm0-1.333H2.667c-.733 0-1.327.6-1.327 1.333l-.007 6.667c0 .733.6 1.333 1.334 1.333h10.667c.733 0 1.333-.6 1.333-1.333V4.667c0-.733-.6-1.333-1.333-1.333m-6 2h1.333v1.333H7.334zm0 2h1.333v1.333H7.334zm-2-2h1.333v1.333H5.334zm0 2h1.333v1.333H5.334zm-2 0h1.333v1.333H3.334zm0-2h1.333v1.333H3.334zm2 4h5.333v1.333H5.334zm4-2h1.333v1.333H9.334zm0-2h1.333v1.333H9.334zm2 2h1.333v1.333h-1.333zm0-2h1.333v1.333h-1.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Keyboard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgKeyboard as ReactComponent };
export default __webpack_public_path__ + "3f3d90500f7c7384fa0adb7947d97569.svg";